<template>
  <tbody>
  <tr v-bind:rowspan="n">
    <td v-bind:colspan="n">
      <div class="container" style="width: 3%; margin: auto;">
        <div class="preloader-wrapper active">
          <div class="spinner-layer spinner-red-only">
            <div class="circle-clipper left">
              <div class="circle"></div>
            </div><div class="gap-patch">
              <div class="circle"></div>
            </div><div class="circle-clipper right">
              <div class="circle"></div>
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>
  </tbody>
</template>

<script>

export default {
  props: {
    n: [String, Number]
  },
}
</script>

<style scoped>

</style>
